import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from 'reactstrap';

interface TabItem {
  title: string;
  permission: string;
  order: number;
}

interface AssignFolderModalProps {
  isOpen: boolean;
  toggle: () => void;
  onConfirm: (selectedTabTitle: string) => void;
  folderTitle: string;
  tabItems: TabItem[];
}

const AssignFolderModal: React.FC<AssignFolderModalProps> = ({
  isOpen,
  toggle,
  onConfirm,
  folderTitle,
  tabItems
}) => {
  const [selectedTab, setSelectedTab] = useState<string>('');

  // Set first tab as selected by default
  useEffect(() => {
    if (tabItems && tabItems.length > 0 && !selectedTab) {
      const firstTab = tabItems.sort((a, b) => a.order - b.order)[0];
      setSelectedTab(firstTab.title);
    }
  }, [tabItems, selectedTab]);

  const handleConfirm = () => {
    if (selectedTab) {
      onConfirm(selectedTab);
    }
  };

  const handleCancel = () => {
    setSelectedTab('');
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleCancel} size="md" centered>
      <ModalHeader toggle={handleCancel}>
        Assign Folder to Tab
      </ModalHeader>
      <ModalBody>
        <p>
          Assign the folder <strong>"{folderTitle}"</strong> to a tab:
        </p>
        <Form>
          <FormGroup>
            <Label for="tabSelect">Select Tab:</Label>
            <Input
              type="select"
              name="tabSelect"
              id="tabSelect"
              value={selectedTab}
              onChange={(e) => setSelectedTab(e.target.value)}
            >
              {tabItems && tabItems.length > 0 ? (
                tabItems
                  .sort((a, b) => a.order - b.order)
                  .map((tab) => (
                    <option key={tab.title} value={tab.title}>
                      {tab.title}
                    </option>
                  ))
              ) : (
                <option disabled>No tabs available</option>
              )}
            </Input>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleCancel}>
          Cancel
        </Button>
        <Button 
          color="primary" 
          onClick={handleConfirm}
          disabled={!selectedTab}
        >
          Assign to Tab
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AssignFolderModal;
